import { render, staticRenderFns } from "./LightboxCustomPanoramaCard.vue?vue&type=template&id=0b836ef8&scoped=true"
import script from "./LightboxCustomPanoramaCard.vue?vue&type=script&lang=js"
export * from "./LightboxCustomPanoramaCard.vue?vue&type=script&lang=js"
import style0 from "./LightboxCustomPanoramaCard.vue?vue&type=style&index=0&id=0b836ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b836ef8",
  null
  
)

export default component.exports